
// Centralized constants for the application

export const COMPANY_INFO = {
  name: "Elevation Electrical, LLC",
  phone: "4079707211",
  formattedPhone: "(407) 970-7211",
  email: "sales@elevationelectricalfl.com",
  license: "EC13011028",
  address: {
    street: "1955 E Kicklighter Road",
    city: "Lake Helen",
    state: "FL",
    zip: "32744",
    full: "1955 E Kicklighter Road, Lake Helen, FL 32744"
  },
  website: "https://www.elevationelectricalfl.com",
  coordinates: {
    latitude: 28.9844,
    longitude: -81.2209
  }
};

export const SERVICE_AREAS = [
  "Lake Helen", "DeLand", "Deltona", "Orange City", "Debary",
  "Sanford", "Lake Mary", "Longwood", "Casselberry", "Winter Springs",
  "Oviedo", "Winter Park", "Orlando", "Apopka", "Altamonte Springs",
  "Daytona Beach", "Ormond Beach", "New Smyrna Beach", "Port Orange"
];

export const CORE_SERVICES = [
  "Panel Upgrades",
  "Generator Installation", 
  "EV Charging Stations",
  "New Construction",
  "Commercial Build-Out",
  "Designer Lighting",
  "Electrical Repairs",
  "Safety Inspections"
];

export const WHY_CHOOSE_US_DEFAULTS = [
  "Licensed contractor (EC13011028)",
  "Expert electrical specialists", 
  "Code compliance guaranteed",
  "Professional installation",
  "Warranty on all work",
  "Fast, reliable service"
];

export const DEFAULT_CTA = {
  title: "Ready to Get Started?",
  subtitle: "Contact Elevation Electrical today for expert service and a free consultation.",
  primaryButtonText: "Call (407) 970-7211",
  primaryButtonLink: "tel:4079707211",
  secondaryButtonText: "Get Free Quote",
  secondaryButtonLink: "/contact"
};

export const MAP_DEFAULTS = {
  center: [29.0275, -81.0964] as [number, number],
  zoom: 10,
  markerText: "Elevation Electrical - Professional Electrical Services"
};
